import InputGroup from "./InputGroup";
import PasswordRequirements from "./PasswordRequirements";

function ForgotPasswordForm({ 
  forgotStep, 
  forgotEmail, 
  setForgotEmail, 
  verificationCode, 
  setVerificationCode,
  password,
  setPassword,
  passwordConfirm,
  setPasswordConfirm,
  handleForgotPasswordNext,
  onCancel
}) {
  return (
    <>
      {forgotStep === 1 && (
        <InputGroup
          label="Email"
          name="forgot-email"
          id="forgot-email"
          value={forgotEmail}
          onChange={(e) => setForgotEmail(e.target.value)}
        />
      )}
      
      {forgotStep === 2 && (
        <InputGroup
          label="Verification Code"
          name="verification-code"
          id="verification-code"
          value={verificationCode}
          onChange={(e) => setVerificationCode(e.target.value)}
        />
      )}
      
      {forgotStep === 3 && (
        <div className="input-group">
          <InputGroup
            label="New Password"
            name="new-password"
            id="new-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <label htmlFor="new-password-confirm">Confirm Password</label>
          <input
            type="password"
            name="new-password-confirm"
            id="new-password-confirm"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
          />
          <PasswordRequirements />
        </div>
      )}

      {forgotStep === 4 && (
        <div className="input-group" style={{ textAlign: 'center', padding: '20px 0' }}>
          <p style={{ fontSize: '1.1rem', color: 'var(--text-primary)', marginBottom: '10px' }}>
            ✓ Password reset successfully!
          </p>
          <p style={{ fontSize: '0.9rem', color: 'var(--text-tertiary)' }}>
            You can now log in with your new password.
          </p>
        </div>
      )}

      <div style={{ display: 'flex', gap: '10px' }}>
        {(forgotStep === 1 || forgotStep === 2 )&& (
          <button type="button" className="sign" onClick={handleForgotPasswordNext} style={{ flex: 1, height: '44px' }}>
            Next
          </button>
        )}
        {forgotStep === 3 && (
          <button type="button" className="sign" onClick={handleForgotPasswordNext} style={{ flex: 1, height: '44px' }}>
            Done
          </button>
        )}
        {forgotStep === 4 && (
          <button type="button" className="sign" onClick={handleForgotPasswordNext} style={{ flex: 1, height: '44px' }}>
            Back to Login
          </button>
        )}
        {forgotStep !== 4 && (
          <button type="button" className="cancel" onClick={onCancel} style={{ flex: 1, height: '44px', marginTop: '0' }}>
            Cancel
          </button>
        )}
      </div>
    </>
  );
}

export default ForgotPasswordForm;
